const soundsData = {
	//music tracks
	music1: {
		src: ["./audio/beat_level_1_a.mp3"]
	},
	music2: {
		src: ["./audio/beat_level_2_a.mp3"]
	},
	music3: {
		src: ["./audio/beat_level_3_b.mp3"],
		loop: true
	},

	//start screen sounds
	startAnimateLogo: {
		src: ["./audio/start-animate-logo.mp3"]
	},
	startThunder: {
		src: ["./audio/start-thunder.mp3"],
		volume: 0.4
	},
	startStartPressed: {
		src: ["./audio/start-start-pressed.mp3"]
	},

	// hits/punches
	
	hit1: {
		src: ["./audio/hit_1_a.mp3"]
	},
	hit2: {
		src: ["./audio/hit_1_b.mp3"]
	},
	hit3: {
		src: ["./audio/hit_1_c.mp3"]
	},
	hit4: {
		src: ["./audio/hit_1_d.mp3"]
	},

	//intro screens sounds
	introClick: {
		src: ["./audio/intro-click.mp3"]
	},
	introShimmer: {
		src: ["./audio/intro-shimmer.mp3"],
		volume: 0.25
	},

	//2D screen sounds
	twoDDarkPatternAppear: {
		src: ["./audio/2d-dark-pattern-appear.mp3"]
	},
	twoDDarkPatternCorrect: {
		src: ["./audio/2d-dark-pattern-correct.mp3"]
	},
	twoDDarkPatternIncorrect: {
		src: ["./audio/2d-dark-pattern-incorrect.mp3"]
	},
	twoDRageIncrease: {
		src: ["./audio/2d-rage-increase.mp3"]
	},
	boxxieKnockout: {
		src: ["./audio/boxxie-knockout.mp3"]
	},

	//3D screen sounds
	threeDCountdown: {
		src: ["./audio/3d-countdown.mp3"],
		volume: 0.7
	},
	threeDCountdownComplete: {
		src: ["./audio/3d-countdown-complete.mp3"],
		volume: 0.7
	},
	threeDSwoosh: {
		src: ["./audio/3d-swoosh.mp3"]
	},

	level1_1: {
		src: ["./audio/level1-beginning-1.mp3"]
	},
	level1_2: {
		src: ["./audio/level1-beginning-2.mp3"]
	},
	level1_3: {
		src: ["./audio/level1-beginning-3.mp3"]
	},
	level1_4: {
		src: ["./audio/level1-beginning-4.mp3"]
	},
	level1_5: {
		src: ["./audio/level1-ending-1.mp3"]
	},
	level2_1: {
		src: ["./audio/level2-beginning-1.mp3"]
	},
	level2_2: {
		src: ["./audio/level2-beginning-2.mp3"]
	},
	level2_3: {
		src: ["./audio/level2-beginning-3.mp3"]
	},
	level2_4: {
		src: ["./audio/level2-beginning-4.mp3"]
	},
	level2_5: {
		src: ["./audio/level2-ending-1.mp3"]
	},
	level3_1: {
		src: ["./audio/level3-beginning-1.mp3"]
	},
	level3_2: {
		src: ["./audio/level3-beginning-2.mp3"]
	},
	level3_3: {
		src: ["./audio/level3-beginning-3.mp3"]
	},
	level3_4: {
		src: ["./audio/level3-beginning-4.mp3"]
	},
	level3_5: {
		src: ["./audio/level3-ending-1.mp3"]
	},
	// removing now to test loading times
	// level1random1: {
	// 	src: ["./audio/level1random1.mp3"]
	// },
	// level1random2: {
	// 	src: ["./audio/level1random2.mp3"]
	// },
	// level1random3: {
	// 	src: ["./audio/level1random3.mp3"]
	// },
	// level1random4: {
	// 	src: ["./audio/level1random4.mp3"]
	// },
	// level1random5: {
	// 	src: ["./audio/level1random5.mp3"]
	// },

	meetboss: {
		src: ["./audio/binary-omnipresent-satisfaction-system.mp3"]
	},
	soundscape: {
		src: ["./audio/soundscape.mp3"],
		loop: true
	},
	dialogMusic: {
		src: ["./audio/waiting_music.mp3"],
		loop: true
	},
	destroyAd1: {
		src: ["./audio/hit_1_a.mp3"],
		volume: 0.4
	},
	destroyAd2: {
		src: ["./audio/hit_1_b.mp3"],
		volume: 0.4
	},
	destroyAd3: {
		src: ["./audio/hit_1_c.mp3"],
		volume: 0.4
	},
	destroyAd4: {
		src: ["./audio/hit_1_d.mp3"]
	},
	// destroyAd5: {
	// 	src: ["./audio/hit_1_b.mp3"]
	// },
	// destroyAd6: {
	// 	src: ["./audio/hit_1_c.mp3"]
	// },
	// destroyAd4: {
	// 	src: ["./audio/ad-destroy4.mp3"]
	// },
	// destroyAd5: {
	// 	src: ["./audio/ad-destroy5.mp3"]
	// },
	// windowAppear: {
	// 	src: ["./audio/windowAppear.mp3"]
	// },
	eas: {
		src: ["./audio/eas.mp3"],
		volume: 0.2
	}
};

export default soundsData;



// WEBPACK FOOTER //
// ./src/soundsData.js